import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _applyCouponRequest = {};
var _applyCouponResponse = { order: '_order' };
var _bulkOrderResult = { order: '_order' };
var _bulkPauseOrderRequest = {};
var _bulkPauseOrderResponse = { results: '_bulkOrderResult' };
var _bulkResumeOrderRequest = {};
var _bulkResumeOrderResponse = { results: '_bulkOrderResult' };
var _cancellation = { requestedDate: 'google.protobuf.Timestamp' };
var _cancelOrderRequest = {};
var _cancelOrderResponse = {};
var _changeStartDateRequest = { startDate: 'google.protobuf.Timestamp' };
var _changeStartDateResponse = { order: '_order' };
var _createExternalOrderRequest = {};
var _createExternalOrderResponse = { order: '_order' };
var _createGuestOnlineOrderRequest = {
    startDate: 'google.protobuf.Timestamp',
};
var _createGuestOnlineOrderResponse = { order: '_order' };
var _createOfflineOrderRequest = { startDate: 'google.protobuf.Timestamp' };
var _createOfflineOrderResponse = { order: '_order' };
var _createOnlineOrderRequest = { startDate: 'google.protobuf.Timestamp' };
var _createOnlineOrderResponse = { order: '_order' };
var _currentCycle = {
    startedDate: 'google.protobuf.Timestamp',
    endedDate: 'google.protobuf.Timestamp',
};
var _getAvailableOrderActionsRequest = {};
var _getAvailableOrderActionsResponse = {};
var _getGuestOnlineOrderPreviewRequest = {
    startDate: 'google.protobuf.Timestamp',
};
var _getGuestOnlineOrderPreviewResponse = { order: '_order' };
var _getOfflineOrderPreviewRequest = {
    startDate: 'google.protobuf.Timestamp',
};
var _getOfflineOrderPreviewResponse = { order: '_order' };
var _getOnlineOrderPreviewRequest = {
    startDate: 'google.protobuf.Timestamp',
};
var _getOnlineOrderPreviewResponse = { order: '_order' };
var _getOrderRequest = {};
var _getOrderResponse = { order: '_order' };
var _getOrdersStatsRequest = {};
var _getOrdersStatsResponse = {};
var _getPricePreviewRequest = {};
var _getPricePreviewResponse = {};
var _listOrdersRequest = {};
var _listOrdersResponse = { orders: '_order' };
var _markAsPaidRequest = {};
var _markAsPaidResponse = {};
var _memberGetOrderRequest = {};
var _memberGetOrderResponse = { order: '_order' };
var _memberListOrdersRequest = {};
var _memberListOrdersResponse = { orders: '_order' };
var _order = {
    startDate: 'google.protobuf.Timestamp',
    endDate: 'google.protobuf.Timestamp',
    earliestEndDate: 'google.protobuf.Timestamp',
    createdDate: 'google.protobuf.Timestamp',
    updatedDate: 'google.protobuf.Timestamp',
    cancellation: '_cancellation',
    pausePeriods: '_pausePeriod',
    currentCycle: '_currentCycle',
    cycles: '_orderCycle',
};
var _orderCycle = {
    startedDate: 'google.protobuf.Timestamp',
    endedDate: 'google.protobuf.Timestamp',
};
var _ordersQueryOrdersRequest = {};
var _ordersQueryOrdersResponse = { plans: '_order' };
var _pauseOrderRequest = {};
var _pauseOrderResponse = {};
var _pausePeriod = {
    pauseDate: 'google.protobuf.Timestamp',
    resumeDate: 'google.protobuf.Timestamp',
};
var _postponeEndDateRequest = { endDate: 'google.protobuf.Timestamp' };
var _postponeEndDateResponse = {};
var _queryOrdersRequest = {};
var _queryOrdersResponse = { plans: '_order' };
var _requestCancellationRequest = {};
var _requestCancellationResponse = {};
var _resumeOrderRequest = {};
var _resumeOrderResponse = {};
var _setSubmissionRequest = {};
var _setSubmissionResponse = { order: '_order' };
function resolveComWixpressMembershipV2OrdersCheckoutServiceUrl(opts) {
    var domainToMappings = {
        'api._api_base_domain_': [
            {
                srcPath: '/pricing-plans-checkout-proxy',
                destPath: '',
            },
        ],
        '*.dev.wix-code.com': [
            {
                srcPath: '/_api/paid-plans/v2/checkout',
                destPath: '/v2/checkout',
            },
        ],
        '*.pub.wix-code.com': [
            {
                srcPath: '/_api/paid-plans/v2/checkout',
                destPath: '/v2/checkout',
            },
        ],
        '*.wixapps.net': [
            {
                srcPath: '/_api/paid-plans/v2/checkout',
                destPath: '/v2/checkout',
            },
        ],
        _: [
            {
                srcPath: '/pricing-plans/v2/checkout',
                destPath: '/v2/checkout',
            },
            {
                srcPath: '/_api/paid-plans/v2/checkout',
                destPath: '/v2/checkout',
            },
            {
                srcPath: '/_api/pricing-plans/v2/checkout',
                destPath: '/v2/checkout',
            },
        ],
        'editor-flow.wixapps.net': [
            {
                srcPath: '/_api/paid-plans/v2/checkout',
                destPath: '/v2/checkout',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/_api/paid-plans/v2/checkout',
                destPath: '/v2/checkout',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/_api/paid-plans/v2/checkout',
                destPath: '/v2/checkout',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/_api/paid-plans/v2/checkout',
                destPath: '/v2/checkout',
            },
        ],
        'editor.wixapps.net': [
            {
                srcPath: '/_api/paid-plans/v2/checkout',
                destPath: '/v2/checkout',
            },
        ],
        'forums._base_domain_': [
            {
                srcPath: '/_api/paid-plans/v2/checkout',
                destPath: '/v2/checkout',
            },
        ],
        'forums.wixapps.net': [
            {
                srcPath: '/_api/paid-plans/v2/checkout',
                destPath: '/v2/checkout',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/_api/pricing-plans/v2/checkout',
                destPath: '/v2/checkout',
            },
            {
                srcPath: '/_api/paid-plans/v2/checkout',
                destPath: '/v2/checkout',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/_api/paid-plans/v2/checkout',
                destPath: '/v2/checkout',
            },
        ],
        'www.wixapis.com': [
            {
                srcPath: '/pricing-plans/v2/checkout',
                destPath: '/v2/checkout',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
function resolveComWixpressMembershipV2OrdersMemberMemberOrdersServiceUrl(opts) {
    var domainToMappings = {
        'api._api_base_domain_': [
            {
                srcPath: '/member-orders-service-proxy',
                destPath: '',
            },
        ],
        '*.dev.wix-code.com': [
            {
                srcPath: '/_api/pricing-plans-member-orders/v2/member/orders',
                destPath: '/v2/member/orders',
            },
            {
                srcPath: '/_api/pricing-plans/v2/member/orders',
                destPath: '/v2/member/orders',
            },
        ],
        '*.pub.wix-code.com': [
            {
                srcPath: '/_api/pricing-plans-member-orders/v2/member/orders',
                destPath: '/v2/member/orders',
            },
            {
                srcPath: '/_api/pricing-plans/v2/member/orders',
                destPath: '/v2/member/orders',
            },
        ],
        _: [
            {
                srcPath: '/_api/pricing-plans/v2/member/orders',
                destPath: '/v2/member/orders',
            },
        ],
        'editor.wixapps.net': [
            {
                srcPath: '/_api/pricing-plans/v2/member/orders',
                destPath: '/v2/member/orders',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/_api/pricing-plans/v2/member/orders',
                destPath: '/v2/member/orders',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/_api/pricing-plans/v2/member/orders',
                destPath: '/v2/member/orders',
            },
        ],
        'www.wixapis.com': [
            {
                srcPath: '/pricing-plans/v2/member/orders',
                destPath: '/v2/member/orders',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
function resolveComWixpressMembershipV2OrdersOrderManagementServiceUrl(opts) {
    var domainToMappings = {
        'api._api_base_domain_': [
            {
                srcPath: '/order-management-service-proxy',
                destPath: '',
            },
        ],
        '*.dev.wix-code.com': [
            {
                srcPath: '/_api/paid-plans/v2/orders',
                destPath: '/v2/orders',
            },
        ],
        '*.pub.wix-code.com': [
            {
                srcPath: '/_api/paid-plans/v2/orders',
                destPath: '/v2/orders',
            },
        ],
        '*.wixapps.net': [
            {
                srcPath: '/_api/paid-plans/v2/orders',
                destPath: '/v2/orders',
            },
        ],
        _: [
            {
                srcPath: '/_api/paid-plans/v2/orders',
                destPath: '/v2/orders',
            },
        ],
        'editor-flow.wixapps.net': [
            {
                srcPath: '/_api/paid-plans/v2/orders',
                destPath: '/v2/orders',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/_api/paid-plans/v2/orders',
                destPath: '/v2/orders',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/_api/paid-plans/v2/orders',
                destPath: '/v2/orders',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/_api/paid-plans/v2/orders',
                destPath: '/v2/orders',
            },
        ],
        'editor.wixapps.net': [
            {
                srcPath: '/_api/paid-plans/v2/orders',
                destPath: '/v2/orders',
            },
        ],
        'forums._base_domain_': [
            {
                srcPath: '/_api/paid-plans/v2/orders',
                destPath: '/v2/orders',
            },
        ],
        'forums.wixapps.net': [
            {
                srcPath: '/_api/paid-plans/v2/orders',
                destPath: '/v2/orders',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/_api/pricing-plans/v2/orders',
                destPath: '/v2/orders',
            },
            {
                srcPath: '/_api/paid-plans/v2/orders',
                destPath: '/v2/orders',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/_api/paid-plans/v2/orders',
                destPath: '/v2/orders',
            },
        ],
        'www.wixapis.com': [
            {
                srcPath: '/pricing-plans/v2/orders',
                destPath: '/v2/orders',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/** Retrieves an order by ID. */
export function managementGetOrder(payload) {
    var _a = serializer(_getOrderRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getOrderResponse, {
        _cancellation: _cancellation,
        _currentCycle: _currentCycle,
        _order: _order,
        _orderCycle: _orderCycle,
        _pausePeriod: _pausePeriod,
    }).fromJSON;
    function __managementGetOrder(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.pricing_plans.v2.order',
            method: 'GET',
            methodFqn: 'com.wixpress.membership.v2.orders.OrderManagementService.GetOrder',
            url: resolveComWixpressMembershipV2OrdersOrderManagementServiceUrl({
                protoPath: '/v2/orders/{id}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __managementGetOrder.fromReq = fromReq;
    __managementGetOrder.__isAmbassador = true;
    return __managementGetOrder;
}
/**
 * Retrieves a list of up to 50 pricing plan orders and details, given the specified sorting and filtering.
 *
 * By default, this endpoint will retrieve all orders and return them sorted by `createdDate` in `DESC`, descending order.
 * `sort.fieldName` supports `endDate` and `createdDate` fields and defaults to `ASC`, ascending order.
 */
export function managementListOrders(payload) {
    var _a = serializer(_listOrdersRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_listOrdersResponse, {
        _cancellation: _cancellation,
        _currentCycle: _currentCycle,
        _order: _order,
        _orderCycle: _orderCycle,
        _pausePeriod: _pausePeriod,
    }).fromJSON;
    function __managementListOrders(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.pricing_plans.v2.order',
            method: 'GET',
            methodFqn: 'com.wixpress.membership.v2.orders.OrderManagementService.ListOrders',
            url: resolveComWixpressMembershipV2OrdersOrderManagementServiceUrl({
                protoPath: '/v2/orders',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData, true),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __managementListOrders.fromReq = fromReq;
    __managementListOrders.__isAmbassador = true;
    return __managementListOrders;
}
/**
 * TODO: Write orders filter and sort docs page
 * Retrieves a list of up to 1,000 orders, based on the provided paging, sorting, and filtering.
 */
export function managementQueryOrders(payload) {
    var _a = serializer(_ordersQueryOrdersRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_ordersQueryOrdersResponse, {
        _cancellation: _cancellation,
        _currentCycle: _currentCycle,
        _order: _order,
        _orderCycle: _orderCycle,
        _pausePeriod: _pausePeriod,
    }).fromJSON;
    function __managementQueryOrders(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.pricing_plans.v2.order',
            method: 'POST',
            methodFqn: 'com.wixpress.membership.v2.orders.OrderManagementService.QueryOrders',
            url: resolveComWixpressMembershipV2OrdersOrderManagementServiceUrl({
                protoPath: '/v2/orders/query',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __managementQueryOrders.fromReq = fromReq;
    __managementQueryOrders.__isAmbassador = true;
    return __managementQueryOrders;
}
/** Retrieves statistics about the pricing plans orders. Currently providing the total number of orders and active orders. */
export function getOrdersStats(payload) {
    var _a = serializer(_getOrdersStatsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getOrdersStatsResponse, {}).fromJSON;
    function __getOrdersStats(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.pricing_plans.v2.order',
            method: 'GET',
            methodFqn: 'com.wixpress.membership.v2.orders.OrderManagementService.GetOrdersStats',
            url: resolveComWixpressMembershipV2OrdersOrderManagementServiceUrl({
                protoPath: '/v2/orders/stats',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getOrdersStats.fromReq = fromReq;
    __getOrdersStats.__isAmbassador = true;
    return __getOrdersStats;
}
export function getAvailableOrderActions(payload) {
    var _a = serializer(_getAvailableOrderActionsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getAvailableOrderActionsResponse, {}).fromJSON;
    function __getAvailableOrderActions(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.pricing_plans.v2.order',
            method: 'GET',
            methodFqn: 'com.wixpress.membership.v2.orders.OrderManagementService.GetAvailableOrderActions',
            url: resolveComWixpressMembershipV2OrdersOrderManagementServiceUrl({
                protoPath: '/v2/orders/{id}/available-owner-actions',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getAvailableOrderActions.fromReq = fromReq;
    __getAvailableOrderActions.__isAmbassador = true;
    return __getAvailableOrderActions;
}
/**
 * Extends the duration of a pricing plan order by postponing the order's `endDate`. Postponing the end date of an order does not impact payments.
 *
 * New `endDate` must be later than the order's current `endDate`. Can't postpone orders that are unlimited.
 * Can't postpone an order with `status`: `PAUSED`.
 */
export function postponeEndDate(payload) {
    var _a = serializer(_postponeEndDateRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_postponeEndDateResponse, {}).fromJSON;
    function __postponeEndDate(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.pricing_plans.v2.order',
            method: 'PATCH',
            methodFqn: 'com.wixpress.membership.v2.orders.OrderManagementService.PostponeEndDate',
            url: resolveComWixpressMembershipV2OrdersOrderManagementServiceUrl({
                protoPath: '/v2/orders/{id}',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __postponeEndDate.fromReq = fromReq;
    __postponeEndDate.__isAmbassador = true;
    return __postponeEndDate;
}
/**
 * Cancels an existing order.
 *
 * For orders with recurring payments, a cancellation can be set to occur either `IMMEDIATELY` or at the `NEXT_PAYMENT_DATE`.
 * For orders with one-time payments, a cancellation can only be set for `IMMEDIATELY`.
 *
 * #### Canceling during the free trial period.
 *
 * When a buyer cancels their order during the free trial period, the buyer's subscription expires at the end
 * of the free trial period and they will not be billed. The buyer may continue using the benefits until the end
 * of the free trial period.
 *
 * When a Wix user cancels an ordered plan during the free trial period, they choose whether to apply the cancellation
 * `IMMEDIATELY` or at the `NEXT_PAYMENT_DATE`. Canceling `IMMEDIATELY` will end the subscription for the buyer
 * immediately, even during the free trial period and the buyer won't be billed. Canceling at the
 * `NEXT_PAYMENT_DATE` allows the buyer to continue using the benefits of the subscription until the end of the free trial period.
 * Then, the subscription ends and the buyer is not billed.
 */
export function cancelOrder(payload) {
    var _a = serializer(_cancelOrderRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_cancelOrderResponse, {}).fromJSON;
    function __cancelOrder(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.pricing_plans.v2.order',
            method: 'POST',
            methodFqn: 'com.wixpress.membership.v2.orders.OrderManagementService.CancelOrder',
            url: resolveComWixpressMembershipV2OrdersOrderManagementServiceUrl({
                protoPath: '/v2/orders/{id}/cancel',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __cancelOrder.fromReq = fromReq;
    __cancelOrder.__isAmbassador = true;
    return __cancelOrder;
}
/**
 * Marks an offline order as paid.
 * > __Note__: Marking separate payment cycles as paid is not yet supported. The entire order will be marked as paid. Subsequent offline payments do trigger events and emails, but are not registered as additional offline payments.
 *
 * Marking an offline order as paid causes the following changes:
 * - The order's `lastPaymentStatus` changes to `"PAID"`.
 * - The order's status changes to either `"PENDING"` or `"ACTIVE"`, depending on the order's `startDate`.
 *
 * An error occurs if you attempt to:
 * - Mark an already-paid, offline order as paid. You cannot mark an offline order as paid twice.
 * - Mark an online order as paid. The Mark as Paid method is supported for offline orders only.
 */
export function markAsPaid(payload) {
    var _a = serializer(_markAsPaidRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_markAsPaidResponse, {}).fromJSON;
    function __markAsPaid(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.pricing_plans.v2.order',
            method: 'POST',
            methodFqn: 'com.wixpress.membership.v2.orders.OrderManagementService.MarkAsPaid',
            url: resolveComWixpressMembershipV2OrdersOrderManagementServiceUrl({
                protoPath: '/v2/orders/{id}/mark-as-paid',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __markAsPaid.fromReq = fromReq;
    __markAsPaid.__isAmbassador = true;
    return __markAsPaid;
}
/**
 * Pauses an order. Calling this method changes the order status to `"PAUSED"` and updates the `pausePeriods` array.
 *
 * Only orders with `status`: `ACTIVE` can be paused.
 * For orders with recurring payments, it also pauses the payment schedule. Buyers are not charged when an order is paused.
 * Pausing an order affects the end date of the order by adding the time the order is paused to the `endDate`.
 * The `endDate` and the `earliestEndDate` for the order are adjusted to include the pause period when the order is resumed.
 *
 * To resume a paused order, call Resume Order.
 */
export function pauseOrder(payload) {
    var _a = serializer(_pauseOrderRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_pauseOrderResponse, {}).fromJSON;
    function __pauseOrder(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.pricing_plans.v2.order',
            method: 'POST',
            methodFqn: 'com.wixpress.membership.v2.orders.OrderManagementService.PauseOrder',
            url: resolveComWixpressMembershipV2OrdersOrderManagementServiceUrl({
                protoPath: '/v2/orders/{id}/pause',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __pauseOrder.fromReq = fromReq;
    __pauseOrder.__isAmbassador = true;
    return __pauseOrder;
}
/** Pauses multiple orders. */
export function bulkPauseOrder(payload) {
    var _a = serializer(_bulkPauseOrderRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkPauseOrderResponse, {
        _bulkOrderResult: _bulkOrderResult,
        _cancellation: _cancellation,
        _currentCycle: _currentCycle,
        _order: _order,
        _orderCycle: _orderCycle,
        _pausePeriod: _pausePeriod,
    }).fromJSON;
    function __bulkPauseOrder(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.pricing_plans.v2.order',
            method: 'POST',
            methodFqn: 'com.wixpress.membership.v2.orders.OrderManagementService.BulkPauseOrder',
            url: resolveComWixpressMembershipV2OrdersOrderManagementServiceUrl({
                protoPath: '/v2/bulk/orders/pause',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkPauseOrder.fromReq = fromReq;
    __bulkPauseOrder.__isAmbassador = true;
    return __bulkPauseOrder;
}
/**
 * Resumes a paused order. For orders with recurring payments, it also restarts the payment schedule.
 *
 * Resuming an order causes the following changes:
 * - The order status changes to `"ACTIVE"`.
 * - The `pausePeriods` array is updated.
 * - The `endDate` for the order is adjusted to include the pause period.
 * - For orders with recurring payments, the payment schedule is restarted.
 * - The `earliestEndDate` is adjusted to include the pause period. (This property is reserved for future use).
 *
 * To pause an order, call Pause Order.
 */
export function resumeOrder(payload) {
    var _a = serializer(_resumeOrderRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_resumeOrderResponse, {}).fromJSON;
    function __resumeOrder(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.pricing_plans.v2.order',
            method: 'POST',
            methodFqn: 'com.wixpress.membership.v2.orders.OrderManagementService.ResumeOrder',
            url: resolveComWixpressMembershipV2OrdersOrderManagementServiceUrl({
                protoPath: '/v2/orders/{id}/resume',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __resumeOrder.fromReq = fromReq;
    __resumeOrder.__isAmbassador = true;
    return __resumeOrder;
}
/** Resumes multiple paused orders. */
export function bulkResumeOrder(payload) {
    var _a = serializer(_bulkResumeOrderRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkResumeOrderResponse, {
        _bulkOrderResult: _bulkOrderResult,
        _cancellation: _cancellation,
        _currentCycle: _currentCycle,
        _order: _order,
        _orderCycle: _orderCycle,
        _pausePeriod: _pausePeriod,
    }).fromJSON;
    function __bulkResumeOrder(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.pricing_plans.v2.order',
            method: 'POST',
            methodFqn: 'com.wixpress.membership.v2.orders.OrderManagementService.BulkResumeOrder',
            url: resolveComWixpressMembershipV2OrdersOrderManagementServiceUrl({
                protoPath: '/v2/bulk/orders/resume',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkResumeOrder.fromReq = fromReq;
    __bulkResumeOrder.__isAmbassador = true;
    return __bulkResumeOrder;
}
/** Retrieves an order for the currently logged-in member by ID. */
export function memberGetOrder(payload) {
    var _a = serializer(_memberGetOrderRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_memberGetOrderResponse, {
        _cancellation: _cancellation,
        _currentCycle: _currentCycle,
        _order: _order,
        _orderCycle: _orderCycle,
        _pausePeriod: _pausePeriod,
    }).fromJSON;
    function __memberGetOrder(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.pricing_plans.v2.order',
            method: 'GET',
            methodFqn: 'com.wixpress.membership.v2.orders.member.MemberOrdersService.GetOrder',
            url: resolveComWixpressMembershipV2OrdersMemberMemberOrdersServiceUrl({
                protoPath: '/v2/member/orders/{id}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __memberGetOrder.fromReq = fromReq;
    __memberGetOrder.__isAmbassador = true;
    return __memberGetOrder;
}
/** Retrieves a list of up to 100 pricing plan orders for currently logged-in member. */
export function memberListOrders(payload) {
    var _a = serializer(_memberListOrdersRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_memberListOrdersResponse, {
        _cancellation: _cancellation,
        _currentCycle: _currentCycle,
        _order: _order,
        _orderCycle: _orderCycle,
        _pausePeriod: _pausePeriod,
    }).fromJSON;
    function __memberListOrders(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.pricing_plans.v2.order',
            method: 'GET',
            methodFqn: 'com.wixpress.membership.v2.orders.member.MemberOrdersService.ListOrders',
            url: resolveComWixpressMembershipV2OrdersMemberMemberOrdersServiceUrl({
                protoPath: '/v2/member/orders',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData, true),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __memberListOrders.fromReq = fromReq;
    __memberListOrders.__isAmbassador = true;
    return __memberListOrders;
}
/** Returns orders for currently logged in member based on provided query */
export function memberQueryOrders(payload) {
    var _a = serializer(_queryOrdersRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_queryOrdersResponse, {
        _cancellation: _cancellation,
        _currentCycle: _currentCycle,
        _order: _order,
        _orderCycle: _orderCycle,
        _pausePeriod: _pausePeriod,
    }).fromJSON;
    function __memberQueryOrders(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.pricing_plans.v2.order',
            method: 'POST',
            methodFqn: 'com.wixpress.membership.v2.orders.member.MemberOrdersService.QueryOrders',
            url: resolveComWixpressMembershipV2OrdersMemberMemberOrdersServiceUrl({
                protoPath: '/v2/member/orders/query',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __memberQueryOrders.fromReq = fromReq;
    __memberQueryOrders.__isAmbassador = true;
    return __memberQueryOrders;
}
/**
 * Cancels an order. Recurring orders can be canceled either immediately or at the next payment date. One time orders can only be canceled immediately.
 *
 * There may be some operations that continue to be processed before the status of the order is changed to `"CANCELED"`. For example, payments might need to be refunded before the order is fully canceled.
 *
 * Canceling during the free trial period: When a buyer cancels their order during the free trial period, the buyer's subscription expires at the end of the free trial period and they won't be billed. The buyer may continue using the benefits until the end of the free trial period.
 *
 * >**Note:**
 * >This method requires [visitor or member authentication](https://dev.wix.com/docs/rest/articles/getting-started/access-types-and-permissions).
 */
export function requestCancellation(payload) {
    var _a = serializer(_requestCancellationRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_requestCancellationResponse, {}).fromJSON;
    function __requestCancellation(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.pricing_plans.v2.order',
            method: 'POST',
            methodFqn: 'com.wixpress.membership.v2.orders.member.MemberOrdersService.RequestCancellation',
            url: resolveComWixpressMembershipV2OrdersMemberMemberOrdersServiceUrl({
                protoPath: '/v2/member/orders/{id}/cancel',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __requestCancellation.fromReq = fromReq;
    __requestCancellation.__isAmbassador = true;
    return __requestCancellation;
}
/**
 * Creates an online order for a site member.
 *
 * If this method is called by a site member ([SDK](https://dev.wix.com/docs/sdk/articles/get-started/about-identities#site-member) | [REST](https://dev.wix.com/docs/rest/articles/getting-started/about-identities#site-member)), the plan is automatically ordered on behalf of that site member. Otherwise, you must specify `onBehalf.memberId` in your call.
 *
 * When an online order is created, but payment hasn't been processed, its status is set to `DRAFT`. After the payment has been processed, if the start date is in the future the order's status is set to `PENDING`. Otherwise, it's set to `ACTIVE`.
 */
export function createOnlineOrder(payload) {
    var _a = serializer(_createOnlineOrderRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_createOnlineOrderResponse, {
        _cancellation: _cancellation,
        _currentCycle: _currentCycle,
        _order: _order,
        _orderCycle: _orderCycle,
        _pausePeriod: _pausePeriod,
    }).fromJSON;
    function __createOnlineOrder(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.pricing_plans.v2.order',
            method: 'POST',
            methodFqn: 'com.wixpress.membership.v2.orders.CheckoutService.CreateOnlineOrder',
            url: resolveComWixpressMembershipV2OrdersCheckoutServiceUrl({
                protoPath: '/v2/checkout/orders/online',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __createOnlineOrder.fromReq = fromReq;
    __createOnlineOrder.__isAmbassador = true;
    return __createOnlineOrder;
}
/**
 * Creates an order and initiates payment for currently logged in member.
 * Will not be exposed to 3rd parties until Wix Payments are exposed.
 * @deprecated Will be removed on 2025-07-31.
 */
export function createGuestOnlineOrder(payload) {
    var _a = serializer(_createGuestOnlineOrderRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_createGuestOnlineOrderResponse, {
        _cancellation: _cancellation,
        _currentCycle: _currentCycle,
        _order: _order,
        _orderCycle: _orderCycle,
        _pausePeriod: _pausePeriod,
    }).fromJSON;
    function __createGuestOnlineOrder(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.pricing_plans.v2.order',
            method: 'POST',
            methodFqn: 'com.wixpress.membership.v2.orders.CheckoutService.CreateGuestOnlineOrder',
            url: resolveComWixpressMembershipV2OrdersCheckoutServiceUrl({
                protoPath: '/v2/checkout/orders/guest-online',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __createGuestOnlineOrder.fromReq = fromReq;
    __createGuestOnlineOrder.__isAmbassador = true;
    return __createGuestOnlineOrder;
}
/**
 * Creates an order for a buyer who purchased the plan with an offline transaction.
 *
 * An offline order is handled off of the Wix site and is marked as `type`: `offline`. If a pricing plan
 * has a limit on the amount of purchases per buyer, that limit is ignored for offline orders.
 * Tax is only applied if the site [has it configured](https://support.wix.com/en/article/pricing-plans-setting-up-tax-collection).
 *
 * When creating a free offline order:
 * The order's status is set to `"PENDING"` if the start date is in the future. Otherwise, the status is set to `"ACTIVE"`.
 * The order's last payment status is set to `"NOT_APPLICABLE"`. "
 *
 * When creating a non-free offline order:
 * The order's status is set to `"PENDING"` if the start date is in the future. Otherwise, the status is set to `"ACTIVE"`.
 * The order's last payment status is set to `"UNPAID"` or `"PAID"` based on the data passed in the `paid` boolean in the request.
 *
 * Payment for an offline order can be set in 1 of 2 ways:
 * + During order creation, set `paid`: `true`.
 * + After creation, call Mark As Paid.
 */
export function createOfflineOrder(payload) {
    var _a = serializer(_createOfflineOrderRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_createOfflineOrderResponse, {
        _cancellation: _cancellation,
        _currentCycle: _currentCycle,
        _order: _order,
        _orderCycle: _orderCycle,
        _pausePeriod: _pausePeriod,
    }).fromJSON;
    function __createOfflineOrder(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.pricing_plans.v2.order',
            method: 'POST',
            methodFqn: 'com.wixpress.membership.v2.orders.CheckoutService.CreateOfflineOrder',
            url: resolveComWixpressMembershipV2OrdersCheckoutServiceUrl({
                protoPath: '/v2/checkout/orders/offline',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __createOfflineOrder.fromReq = fromReq;
    __createOfflineOrder.__isAmbassador = true;
    return __createOfflineOrder;
}
/**
 * Creates an order with payment method "EXTERNAL" and initiates payment for currently logged in member.
 * Will not be exposed to 3rd parties until Wix Payments are exposed.
 */
export function createExternalOrder(payload) {
    var _a = serializer(_createExternalOrderRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_createExternalOrderResponse, {
        _cancellation: _cancellation,
        _currentCycle: _currentCycle,
        _order: _order,
        _orderCycle: _orderCycle,
        _pausePeriod: _pausePeriod,
    }).fromJSON;
    function __createExternalOrder(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.pricing_plans.v2.order',
            method: 'POST',
            methodFqn: 'com.wixpress.membership.v2.orders.CheckoutService.CreateExternalOrder',
            url: resolveComWixpressMembershipV2OrdersCheckoutServiceUrl({
                protoPath: '/v2/checkout/orders/external',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __createExternalOrder.fromReq = fromReq;
    __createExternalOrder.__isAmbassador = true;
    return __createExternalOrder;
}
/**
 * Returns an `order` object that represents a potential online order for a site member.
 *
 * You can use this method to show a site member a preview of an online order before [creating](https://dev.wix.com/docs/rest/business-solutions/pricing-plans/pricing-plans/orders/create-online-order) it.
 *
 * This method must be called using the site member identity ([SDK](https://dev.wix.com/docs/sdk/articles/get-started/about-identities#site-member) | [REST](https://dev.wix.com/docs/rest/articles/getting-started/about-identities#site-member)). Therefore, [Wix apps](https://dev.wix.com/docs/build-apps) can't currently call this method using REST.
 */
export function getOnlineOrderPreview(payload) {
    var _a = serializer(_getOnlineOrderPreviewRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getOnlineOrderPreviewResponse, {
        _cancellation: _cancellation,
        _currentCycle: _currentCycle,
        _order: _order,
        _orderCycle: _orderCycle,
        _pausePeriod: _pausePeriod,
    }).fromJSON;
    function __getOnlineOrderPreview(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.pricing_plans.v2.order',
            method: 'POST',
            methodFqn: 'com.wixpress.membership.v2.orders.CheckoutService.GetOnlineOrderPreview',
            url: resolveComWixpressMembershipV2OrdersCheckoutServiceUrl({
                protoPath: '/v2/checkout/orders/preview-online',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getOnlineOrderPreview.fromReq = fromReq;
    __getOnlineOrderPreview.__isAmbassador = true;
    return __getOnlineOrderPreview;
}
/**
 * Forms an order preview using same logic as purchasing, except that it is not persisted anywhere.
 * Checks for purchase limitations
 * [More information on tax here](https://support.wix.com/en/article/pricing-plans-setting-up-tax-collection).
 * Will not be exposed until CreateGuestOnlineOrder is exposed.
 * @deprecated Will be removed on 2025-07-31.
 */
export function getGuestOnlineOrderPreview(payload) {
    var _a = serializer(_getGuestOnlineOrderPreviewRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getGuestOnlineOrderPreviewResponse, { _cancellation: _cancellation, _currentCycle: _currentCycle, _order: _order, _orderCycle: _orderCycle, _pausePeriod: _pausePeriod }).fromJSON;
    function __getGuestOnlineOrderPreview(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.pricing_plans.v2.order',
            method: 'POST',
            methodFqn: 'com.wixpress.membership.v2.orders.CheckoutService.GetGuestOnlineOrderPreview',
            url: resolveComWixpressMembershipV2OrdersCheckoutServiceUrl({
                protoPath: '/v2/checkout/orders/preview-guest-online',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getGuestOnlineOrderPreview.fromReq = fromReq;
    __getGuestOnlineOrderPreview.__isAmbassador = true;
    return __getGuestOnlineOrderPreview;
}
/**
 * Performs a dry run of a purchase and provides an order preview.
 *
 * The preview uses the same logic as purchasing a plan, but the preview is not saved. Because an order is not actually
 * created, the preview order's `orderId` and `subscriptionId` are displayed as a string of multiple zero characters
 * (`000000-0000`). Tax is only calculated if the site [has it configured](https://support.wix.com/en/article/pricing-plans-setting-up-tax-collection).
 * <br>
 * If a pricing plan has a limit on the amount of purchases per buyer, that limit is not considered for generating the preview.
 * But, if that limit has been reached and this order would then exceed the amount of purchases permitted for this buyer, then
 * `purchaseLimitExceeded` will return as `true`.
 *
 * To get a general price preview for a plan that's not buyer-specific, call Get Price Preview.
 */
export function getOfflineOrderPreview(payload) {
    var _a = serializer(_getOfflineOrderPreviewRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getOfflineOrderPreviewResponse, {
        _cancellation: _cancellation,
        _currentCycle: _currentCycle,
        _order: _order,
        _orderCycle: _orderCycle,
        _pausePeriod: _pausePeriod,
    }).fromJSON;
    function __getOfflineOrderPreview(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.pricing_plans.v2.order',
            method: 'POST',
            methodFqn: 'com.wixpress.membership.v2.orders.CheckoutService.GetOfflineOrderPreview',
            url: resolveComWixpressMembershipV2OrdersCheckoutServiceUrl({
                protoPath: '/v2/checkout/orders/preview-offline',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getOfflineOrderPreview.fromReq = fromReq;
    __getOfflineOrderPreview.__isAmbassador = true;
    return __getOfflineOrderPreview;
}
/**
 * Retrieves a plan's pricing.
 *
 * The price preview uses the same logic as purchasing a plan, but the preview is not saved. Tax is only applied if
 * the site [has it configured](https://support.wix.com/en/article/pricing-plans-setting-up-tax-collection). The price is returned
 * in the pricing model format used for orders. Learn more about pricing models ([REST](https://dev.wix.com/api/rest/wix-pricing-plans/pricing-plans/introduction#wix-pricing-plans_pricing-plans_introduction_pricing-models)|[SDK](https://dev.wix.com/docs/sdk/backend-modules/pricing-plans/introduction#pricing-models)).
 *
 * Buyers do not have to be logged in to preview the price, and as such, the details returned are not buyer-specific. To
 * generate a preview of a purchase for a specific buyer, call Get Offline Order Preview.
 */
export function getPricePreview(payload) {
    var _a = serializer(_getPricePreviewRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getPricePreviewResponse, {}).fromJSON;
    function __getPricePreview(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.pricing_plans.v2.order',
            method: 'POST',
            methodFqn: 'com.wixpress.membership.v2.orders.CheckoutService.GetPricePreview',
            url: resolveComWixpressMembershipV2OrdersCheckoutServiceUrl({
                protoPath: '/v2/checkout/orders/price-preview',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getPricePreview.fromReq = fromReq;
    __getPricePreview.__isAmbassador = true;
    return __getPricePreview;
}
/**
 * Changes the start date of a draft order.
 *
 * Deprecated: use CreateOnlineOrder or CreateOfflineOrder with the desired start date to create a new order
 * instead.
 * @deprecated It has been replaced with com.wixpress.membership.v2.orders.CheckoutService.CreateOnlineOrder(), and will be removed on 2025-07-31.
 */
export function changeStartDate(payload) {
    var _a = serializer(_changeStartDateRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_changeStartDateResponse, {
        _cancellation: _cancellation,
        _currentCycle: _currentCycle,
        _order: _order,
        _orderCycle: _orderCycle,
        _pausePeriod: _pausePeriod,
    }).fromJSON;
    function __changeStartDate(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.pricing_plans.v2.order',
            method: 'PATCH',
            methodFqn: 'com.wixpress.membership.v2.orders.CheckoutService.ChangeStartDate',
            url: resolveComWixpressMembershipV2OrdersCheckoutServiceUrl({
                protoPath: '/v2/checkout/orders/order/{orderId}',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __changeStartDate.fromReq = fromReq;
    __changeStartDate.__isAmbassador = true;
    return __changeStartDate;
}
/**
 * Applies a coupon to an order and recalculates tax if needed. Should be called at the last moment before the payment.
 * If you don't want to make change to an order and only want to see the plan price with applied coupon
 * you can use GetPricePreview, GetOnlineOrderPreview or GetOfflineOrderPreview endpoints with coupon code.
 *
 * Deprecated: use CreateOnlineOrder or CreateOfflineOrder with the coupon code to create a new order with the
 * coupon applied instead.
 * @deprecated It has been replaced with com.wixpress.membership.v2.orders.CheckoutService.CreateOnlineOrder(), and will be removed on 2025-07-31.
 */
export function applyCoupon(payload) {
    var _a = serializer(_applyCouponRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_applyCouponResponse, {
        _cancellation: _cancellation,
        _currentCycle: _currentCycle,
        _order: _order,
        _orderCycle: _orderCycle,
        _pausePeriod: _pausePeriod,
    }).fromJSON;
    function __applyCoupon(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.pricing_plans.v2.order',
            method: 'POST',
            methodFqn: 'com.wixpress.membership.v2.orders.CheckoutService.ApplyCoupon',
            url: resolveComWixpressMembershipV2OrdersCheckoutServiceUrl({
                protoPath: '/v2/checkout/orders/{orderId}/apply-coupon',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __applyCoupon.fromReq = fromReq;
    __applyCoupon.__isAmbassador = true;
    return __applyCoupon;
}
/**
 * Adds to a draft order reference to a submission. Member can only revise orders what were created by them.
 *
 * Deprecated: use CreateOnlineOrder or CreateOfflineOrder with the submission to create a new order with submission
 * instead.
 * @deprecated It has been replaced with com.wixpress.membership.v2.orders.CheckoutService.CreateOnlineOrder(), and will be removed on 2025-07-31.
 */
export function setSubmission(payload) {
    var _a = serializer(_setSubmissionRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_setSubmissionResponse, {
        _cancellation: _cancellation,
        _currentCycle: _currentCycle,
        _order: _order,
        _orderCycle: _orderCycle,
        _pausePeriod: _pausePeriod,
    }).fromJSON;
    function __setSubmission(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.pricing_plans.v2.order',
            method: 'POST',
            methodFqn: 'com.wixpress.membership.v2.orders.CheckoutService.SetSubmission',
            url: resolveComWixpressMembershipV2OrdersCheckoutServiceUrl({
                protoPath: '/v2/checkout/orders/{orderId}/set-submission',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __setSubmission.fromReq = fromReq;
    __setSubmission.__isAmbassador = true;
    return __setSubmission;
}
//# sourceMappingURL=http.impl.js.map